import React from 'react';
import { useInView } from 'react-intersection-observer';
import aboutPImg from '../assets/about_p.png';

interface AboutProps {
  language: string;
  onLanguageChange: (lang: string) => void;
}

const About: React.FC<AboutProps> = ({ language, onLanguageChange }) => {
  const { ref: contentRef, inView: contentVisible } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="company-profile" className="py-24 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-16">
          <div 
            className={`flex-1 min-w-[300px] ${contentVisible ? 'animate-slide-right' : 'opacity-0'}`}
            ref={contentRef}
          >
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-heading-lg text-blue-900 section-heading-underline">
                {language === 'zh' ? '公司簡介' : 'Company Profile'}
              </h2>
            </div>
            
            <div className="space-y-6">
              <p className="text-body-md text-gray-700">
                {language === 'zh'
                  ? '迪衡數位科技是人工智慧解決方案的領先創新者，提供尖端技術與策略，徹底改變企業運作方式。我們專業的工程師與顧問團隊攜手合作，設計客製化方案，解決當今科技快速演進下的複雜挑戰。'
                  : 'DHT Solution is a leading innovator in artificial intelligence solutions, providing cutting-edge technologies and strategies that transform how businesses operate. Our dedicated team of engineers and consultants work collaboratively to design customized solutions that address complex challenges in today\'s rapidly evolving technological landscape.'}
              </p>
              
              <p className="text-body-md text-gray-700">
                {language === 'zh'
                  ? '我們相信 AI 的變革力量能徹底革新決策流程、優化營運並創造全新成長機會。我們的使命是讓先進的人工智慧技術對各行各業的組織都能產生實質影響。'
                  : 'We believe in the transformative power of AI to revolutionize decision-making processes, optimize operations, and create new opportunities for growth. Our mission is to make advanced artificial intelligence technology accessible and impactful for organizations of all sizes across diverse industries.'}
              </p>
              
              <div className="flex flex-wrap gap-4 pt-4">
                <div className="bg-blue-50 rounded-lg px-4 py-3 border border-blue-100">
                  <span className="text-blue-900 font-semibold block mb-1">{language === 'zh' ? '成立年份' : 'Founded'}</span>
                  <span className="text-gray-700">2018</span>
                </div>
                
                <div className="bg-blue-50 rounded-lg px-4 py-3 border border-blue-100">
                  <span className="text-blue-900 font-semibold block mb-1">{language === 'zh' ? '總部' : 'Headquarters'}</span>
                  <span className="text-gray-700">{language === 'zh' ? '台灣台北' : 'Taipei, Taiwan'}</span>
                </div>
                
                <div className="bg-blue-50 rounded-lg px-4 py-3 border border-blue-100">
                  <span className="text-blue-900 font-semibold block mb-1">{language === 'zh' ? '人力資源' : 'Team Size'}</span>
                  <span className="text-gray-700">{language === 'zh' ? '15＋ AI 工程師' : '15+ AI Professionals'}</span>
                </div>
              </div>
              
              <a 
                href="#contact" 
                className="button-primary inline-block mt-4"
              >
                {language === 'zh' ? '聯絡我們' : 'Connect With Us'}
              </a>
            </div>
          </div>
          
          <div 
            className={`flex-1 min-w-[300px] transition-all duration-1000 ${
              contentVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <div className="relative">
              <div className="absolute -top-3 -left-3 w-24 h-24 bg-blue-100 rounded-lg"></div>
              <div className="absolute -bottom-3 -right-3 w-24 h-24 bg-blue-200 rounded-lg"></div>
              
              <div className="relative rounded-lg overflow-hidden shadow-lg border-8 border-white">
                <img 
                  src={aboutPImg} 
                  alt="DHT Solution Team" 
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-6 right-12 bg-white py-2 px-6 rounded-lg shadow-md">
                <span className="text-blue-900 font-semibold">{language === 'zh' ? 'AI 智能解決方案' : 'AI-Powered Solutions'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;